export const CONSTANTS = {
  MIN_FILTER_LENGTH: 3,
  DEBOUNCE_DELAY: 300,
  DEFAULT_PLACEHOLDER: "Enter company name, url or DUNS",
  MIN_CHAR_MESSAGE: "Please enter at least 3 characters",
};

export const QUERY_ARGS = {
  per: 15,
  sort: [{ field: "REVENUE_RANGE_MIN", direction: "DESC" as const }],
};
